{
  "learn_more": "Learn more",
  "go_to_settings": "Go to settings",
  "upgrade_plan": "Upgrade plan",
  "explore_more": "Explore more",
  "contact_us": "Contact us",
  "manage_sparkjs_version": "Manage Core Script version"
}
